module.exports = "<h2 class=\"display-3\" >Witaj w systemie komunikacji miejskiej!</h2>\n<br>\n<p class=\"text-center\" id=\"podpowitanie\">System stworzony w ramach pracy inżynierskiej. <br><br><br>\n    <button type=\"button\" class=\"btn btn-danger\" routerLink=\"/about\">\n        Dowiedź się więcej\n    </button>\n</p>"


//////////////////
// WEBPACK FOOTER
// ./src/app/main/main.component.html
// module id = ./src/app/main/main.component.html
// module chunks = main